import React, { useCallback } from "react";

import { TodoPriorityValue } from "widgets/src/Todo/TodoPriorities";
import { TodoToolbarButtonTags_tags$key } from "widgets/src/Todo/TodoToolbar/__generated__/TodoToolbarButtonTags_tags.graphql";
import { TodoToolbarButtonTeams_teams$key } from "widgets/src/Todo/TodoToolbar/__generated__/TodoToolbarButtonTeams_teams.graphql";
import { TodoToolbarButtonTeams } from "./TodoToolbarButtonTeams";
import { ToolbarButtonAssignees } from "./ToolbarButtonAssignees";
import { TodoToolbarButtonDeadline } from "./TodoToolbarButtonDeadline";
import { TodoToolbarButtonPrio } from "./TodoToolbarButtonPrio";
import { TodoToolbarButtonTags } from "./TodoToolbarButtonTags";
import { ToolbarButtonAssignees_employees$key } from "./__generated__/ToolbarButtonAssignees_employees.graphql";
import { ToolbarButtonAssignees_roles$key } from "./__generated__/ToolbarButtonAssignees_roles.graphql";

export type TodoToolbarItemFeature =
  | {
      teams: TodoToolbarButtonTeams_teams$key;
      feature: "TEAM";
    }
  | {
      assignedEmployees: ToolbarButtonAssignees_employees$key;
      assignedRoles: ToolbarButtonAssignees_roles$key;
      feature: "ASSIGNEE";
    }
  | {
      expireAt:
        | {
            date: Date;
            formattedDate: string;
          }
        | undefined;

      feature: "DEADLINE";
    }
  | {
      priority: TodoPriorityValue;
      feature: "PRIORITY";
    }
  | {
      tags: TodoToolbarButtonTags_tags$key;
      feature: "TAG";
    };

export type ToolbarFeature = TodoToolbarItemFeature["feature"];
export const TodoToolbarItem = React.memo(TodoToolbarItemC);
function TodoToolbarItemC(props: {
  feature: TodoToolbarItemFeature;
  onPress: (feature: ToolbarFeature) => void;
  mode: "hidden" | "locked-active" | "active" | "inactive";
  isReadOnly: boolean;
  currentEmployeeId?: string;
}) {
  const _onPress = props.onPress;
  const featureKey = props.feature.feature;
  const onPress = useCallback(() => {
    _onPress(featureKey);
  }, [_onPress, featureKey]);
  const locked = props.mode === "locked-active" || props.isReadOnly;

  switch (props.feature.feature) {
    case "TEAM":
      return (
        <TodoToolbarButtonTeams
          teams={props.feature.teams}
          onPress={onPress}
          isLocked={locked}
        />
      );
    case "ASSIGNEE":
      return (
        <ToolbarButtonAssignees
          onPress={onPress}
          assignedEmployees={props.feature.assignedEmployees}
          assignedRoles={props.feature.assignedRoles}
          isLocked={locked}
        />
      );
    case "DEADLINE":
      return (
        <TodoToolbarButtonDeadline
          expireAt={props.feature.expireAt}
          onPress={onPress}
          isLocked={locked}
        />
      );
    case "PRIORITY":
      return (
        <TodoToolbarButtonPrio
          prio={props.feature.priority}
          onPress={onPress}
          isLocked={locked}
        />
      );
    case "TAG":
      return (
        <TodoToolbarButtonTags tags={props.feature.tags} onPress={onPress} />
      );
  }

  return null;
}
